import {
  SET_QUEUE_VISIBILITY,
  SET_GENRES_LIST_STATE,
  SET_PAGE_STATUS,
  SET_PAGE_ERROR_CODE,
  ADD_PAGE_ERROR,
  CLEAR_PAGE_ERRORS,
  SET_PAGE_TITLE
} from "@/store/mutation-types";

export default {
  openQueue({ commit, state }) {
    if (!state.queue) {
      commit(SET_QUEUE_VISIBILITY, true);
    }
  },
  closeQueue({ commit, state }) {
    if (state.queue) {
      commit(SET_QUEUE_VISIBILITY, false);
    }
  },
  toggleQueue({ commit, state }) {
    commit(SET_QUEUE_VISIBILITY, !state.queue);
  },
  setTitle({ commit, getters, rootGetters }) {
    if (getters["errorCode"]) {
      if (getters["errorCode"] === "notFound") {
        document.title = this.$app.$l10n("PAGE_NOT_FOUND");
      }
      if (getters["errorCode"] === "serviceError") {
        document.title = this.$app.$l10n("ERROR_WHILE_LOAD");
      }
    } else {
      if (this.$app.$route.meta.title) {
        document.title = this.$app.$route.meta.title;
      }

      const running = rootGetters["player/running"];

      if (running) {
        const tracks = rootGetters["tracks/tracks"];
        const currentTrackId = rootGetters["queue/currentTrackId"];
        const currentTrack = tracks[currentTrackId];

        if (currentTrack) {
          document.title = `♫ ${currentTrack.name}`;
        }
      }
    }

    commit(SET_PAGE_TITLE, document.title);
  },
  setStatus({ commit }, status) {
    if (status) {
      commit(SET_PAGE_STATUS, status);
    }
  },
  setGenresListState({ commit }, newState) {
    commit(SET_GENRES_LIST_STATE, newState);
  },
  showGenresList({ commit }) {
    commit(SET_GENRES_LIST_STATE, { visible: true });
  },
  hideGenresList({ commit }) {
    commit(SET_GENRES_LIST_STATE, { visible: false });
  },
  setErrorCode({ commit }, code = null) {
    commit(SET_PAGE_ERROR_CODE, code);
  },
  addError({ commit }, error) {
    commit(ADD_PAGE_ERROR, error);
  },
  clearErrors({ commit }) {
    commit(CLEAR_PAGE_ERRORS);
  }
};
